import { Type } from "class-transformer";
import { CertificateGrade } from "./certificate-grade.entity";
import { ExamGradeUpsertDto } from "./exam-grade-upsert.dto";
import { Exam } from "./exam.entity";

export class GradeBookSchoolClassUpsertDto {
    id = 0;
    isHalfYear = false;

    @Type(() => Exam)
    addedExams: Exam[];
    @Type(() => Exam)
    changedExams: Exam[];
    removedExamIds: number[];

    @Type(() => ExamGradeUpsertDto)
    addedGrades: ExamGradeUpsertDto[];
    @Type(() => ExamGradeUpsertDto)
    changedGrades: ExamGradeUpsertDto[];
    removedGradeIds: number[];

    @Type(() => CertificateGrade)
    changedCertificateGrades: CertificateGrade[];

    anyChanges(): boolean {
        return this.addedExams.length > 0 ||   
            this.changedExams.length > 0 || 
            this.removedExamIds.length > 0 || 
            this.addedGrades.length > 0 || 
            this.changedGrades.length > 0 ||
            this.removedGradeIds.length > 0 ||
            this.changedCertificateGrades?.length > 0;
    }
}
